import { BaseSchema } from 'yup';

type ConcatMultiSchemasType = (p: { schema: BaseSchema, otherSchemas: BaseSchema[] }) => BaseSchema;
export const concatMultiSchemas: ConcatMultiSchemasType = ({ schema: mainSchema, otherSchemas }) => (
  otherSchemas.reduce((schema, schemaToConcat) => schema.concat(schemaToConcat), mainSchema.clone())
);
